exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-attribute-image{width:200px;height:200px;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/template/sections/content/pricing-table/product-custom-attribute/components/productCustomAttributesImageSelect/ProductCustomAttributesComponent.scss
// module id = 6200
// module chunks = 0